import React, { useEffect, useState } from "react";
import { Button, Modal, Form, Input, Table, message, Select } from "antd";
import { PlusOutlined, EditOutlined } from "@ant-design/icons";
import {
  create_test_department,
  fetch_test_departments,
  update_test_department,
} from "../../endpoints/API";

const { Option } = Select;

const TestDepartment = () => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [departmentForm] = Form.useForm();
  const [departments, setDepartments] = useState([]);
  const [isEditMode, setIsEditMode] = useState(false);
  const [editId, setEditId] = useState(null);

  const loadDepartments = async () => {
    try {
      const response = await fetch_test_departments();
      setDepartments(response.data);
    } catch (error) {
      message.error("Failed to fetch departments");
    }
  };

  useEffect(() => {
    loadDepartments();
  }, []);

  const showModal = () => {
    setIsModalVisible(true);
    setIsEditMode(false);
    setEditId(null);
    departmentForm.resetFields();
  };

  const handleEdit = (record) => {
    setIsModalVisible(true);
    setIsEditMode(true);
    setEditId(record.id);

    departmentForm.setFieldsValue({
      name: record.name,
      description: record.description,
    });
  };

  const handleSubmit = async (values) => {
    try {
      if (isEditMode) {
        await update_test_department(editId, values);
        message.success("Department updated successfully");
      } else {
        await create_test_department(values);
        message.success("Department created successfully");
      }

      setIsModalVisible(false);
      departmentForm.resetFields();
      loadDepartments();
    } catch (error) {
      message.error(error?.response?.data?.error || "Operation failed");
    }
  };

  const columns = [
    {
      title: "Department Name",
      dataIndex: "name",
      key: "name",
      render: (text) => text.toUpperCase(),
    },
    {
      title: "Description",
      dataIndex: "description",
      key: "description",
    },
    {
      title: "Action",
      key: "action",
      render: (_, record) => (
        <Button type="link" onClick={() => handleEdit(record)}>
          <EditOutlined />
        </Button>
      ),
    },
  ];

  return (
    <div>
      <div style={{ textAlign: "right", marginBottom: 20 }}>
        <Button type="primary" icon={<PlusOutlined />} onClick={showModal}>
          Create Department
        </Button>
      </div>

      <Table
        dataSource={departments}
        columns={columns}
        rowKey="id"
        bordered
        pagination={{ pageSize: 5 }}
      />

      <Modal
        title={isEditMode ? "Edit Department" : "Create Department"}
        open={isModalVisible}
        onCancel={() => setIsModalVisible(false)}
        footer={null}
      >
        <Form
          form={departmentForm}
          layout="vertical"
          onFinish={handleSubmit}
        >
          <Form.Item
            label="Department Name"
            name="name"
            rules={[{ required: true, message: "Please select department" }]}
          >
            <Select placeholder="Select department">
              <Option value="pathology">Pathology</Option>
              <Option value="radiology">Radiology</Option>
              <Option value="cardiology">Cardiology</Option>
              <Option value="neurology">Neurology</Option>
              <Option value="orthopedics">Orthopedics</Option>
              <Option value="dermatology">Dermatology</Option>
              <Option value="gastroenterology">Gastroenterology</Option>
              <Option value="urology">Urology</Option>
              <Option value="pulmonology">Pulmonology</Option>
              <Option value="endocrinology">Endocrinology</Option>
              <Option value="specialistconsultation">
                Specialist Consultation
              </Option>
              <Option value="ophthalmology">Ophthalmology</Option>
            </Select>
          </Form.Item>

          <Form.Item
            label="Description"
            name="description"
            rules={[{ required: true, message: "Please enter description" }]}
          >
            <Input.TextArea rows={3} />
          </Form.Item>

          <Form.Item>
            <div style={{ textAlign: "right" }}>
              <Button type="primary" htmlType="submit">
                {isEditMode ? "Update" : "Submit"}
              </Button>
            </div>
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
};

export default TestDepartment;
